"use client";

import React from "react";
import ContactForm from "./ContactForm";
import Image from "next/image";

const BuildingTogether = () => {
  return (
    <div
      id="contact-us"
      className="relative max-w-[1525px] w-full flex items-center justify-center mt-14"
    >
      {/* Background Image */}
      <Image
        src="/images/BuildingTogether.png"
        alt="Background Pattern"
        fill
        className="object-cover"
      />

      {/* Content Container */}
      <div className="relative z-20 container mx-auto sm:px-4">
        <div className="bg-black/30 backdrop-blur-lg max-w-[1250px] mx-auto overflow-hidden">
          <div className="flex flex-col md:flex-row">
            {/* Left Column - Text */}
            <div className="w-full hidden md:w-[60%] p-8 sm:flex items-center">
              <h1 className="px-18 text-6xl font-bold text-white leading-tight">
                Let&apos;s Make
                <br />
                Ideas Into
                <br />
                Reality.
              </h1>
            </div>

            {/* Divider Line */}
            <div className="hidden md:block w-px bg-white/70 mx-2 self-stretch my-8"></div>

            {/* Right Column - Form */}
            <div className="w-full sm:w-[70%] p-4 py-9 pb-10 sm:p-14 sm:py-14 sm:pb-14 sm:px-44">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuildingTogether;
